import { createFileRoute } from '@tanstack/react-router';
import { PermissionGate } from '@/components/PermissionGate';
import { DesktopVersionsList } from '@/features/desktop-versions/components/DesktopVersionsList';

export const Route = createFileRoute('/_authenticated/desktop-versions')({
  component: DesktopVersionsPage,
});

function DesktopVersionsPage() {
  return (
    <PermissionGate permission="desktop.versions.manage">
      <div className="container mx-auto py-6">
        <DesktopVersionsList />
      </div>
    </PermissionGate>
  );
}

